import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const shopReviewsSwiper = document.querySelector(".js-shop-reviews-swiper-init");

if (shopReviewsSwiper) {
    initIntersectionObserver(shopReviewsSwiper, initShopReviewsSlider);
}

function initShopReviewsSlider(slider) {
    const swiperContainer = slider.querySelector(".swiper");

    if (swiperContainer) {
        new Swiper(swiperContainer, {
            modules: [Pagination, Manipulation],
            speed: 400,
            spaceBetween: 17,
            slidesPerView: 1,
            breakpoints: {
                767: {
                    slidesPerView: 2,
                },
            },
            watchOverflow: true,
            navigation: {
                nextEl: ".js-shop-reviews-controls > .swiper-button-next",
                prevEl: ".js-shop-reviews-controls > .swiper-button-prev",
            },
        });
    }
}
